var $ = jQuery.noConflict();

jQuery(window).on('load', function() {
	hidePreloader();
});

function hidePreloader() {
    jQuery('section.preloader-wrapper').each(function(){
        jQuery(this).removeClass('show');
        jQuery(this).addClass('done');
        setTimeout(function() {
            jQuery('section.preloader-wrapper').remove();
        }, 500);
    })
}
